site.popUp = {
	init: function() {
		var popUp = document.getElementById("signUppopUp");
		var loggedIn = $( "#virk__nav" ).hasClass( "loggedIn" );
		if (!popUp || loggedIn) {
			return;
		}
		var close = document.getElementById("closePopUp");

		close.onclick = function() {
			popUp.style.display = "none";
		};
		window.onclick = function(event) {
			if (event.target === popUp) {
				popUp.style.display = "none";
			}
		};
		if(!sessionStorage.getItem("hasSeenPopUp") && !$('body').is('.admin') && !$('body').is('.auth')) {
			window.onload = (event) => {
				popUp.style.display = "block";
				sessionStorage.setItem("hasSeenPopUp", "seen");
			};
		}
	}
};
site.inits.push('site.popUp.init()');
